module.exports = __webpack_public_path__ + "img/programLogoBG.bf254584.png";